const KG_TO_TONNES = 0.001;
const TO_PERCENTAGE = 100;

export default {
  KG_TO_TONNES,
  TO_PERCENTAGE,
};
